// Base Client
import { getApiToken } from "../helpers";
import { getBffRequest } from "./base/api";
import { RpcError, StatusCode } from "grpc-web";

// Protos
import { ClaimsBFFControllerClient } from "./protos/Claims-bffServiceClientPb";
import {
	ListLegalBenefitsRequest,
	ListLegalBenefitsResponse,
	GetLegalBenefitByIdRequest,
	GetLegalBenefitByIdResponse,
	ListMatterBillingCodesRequest,
	ListMatterBillingCodesResponse
} from "./protos/messages/benefits.message_pb";

export const listLegalBenefits = async (
	lgPolicyId: number,
	attyId?: number,
	caseId?: number
): Promise<ListLegalBenefitsResponse> => {
	const token: string = getApiToken();

	const request: ListLegalBenefitsRequest = new ListLegalBenefitsRequest();
	request.setLgPolicyId(lgPolicyId);
	if (attyId) {
		request.setAttyId(attyId);
	}
	if (caseId) {
		request.setCaseId(caseId);
	}

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	try {
		return await client.listLegalBenefits(request, {});
	} catch (err) {
		console.error(err);
		throw err;
	}
};

export const getLegalBenefitById = async (
	legalBenefitId: number,
	attyId?: number,
	caseId?: number
): Promise<GetLegalBenefitByIdResponse> => {
	const token: string = getApiToken();

	const request: GetLegalBenefitByIdRequest = new GetLegalBenefitByIdRequest();
	request.setId(legalBenefitId);
	if (attyId) {
		request.setAttyId(attyId);
	}
	if (caseId) {
		request.setCaseId(caseId);
	}

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	try {
		return await client.getLegalBenefitById(request, {});
	} catch (err) {
		// Check if this is a NotFound error
		const error = err as RpcError;
		if (error.code === 13 || error.message?.includes("NotFound")) {
			// For NotFound errors, just log to console, don't propagate the error
			console.warn(`LegalBenefit not found: ${legalBenefitId}`, error);

			// Return an empty response instead of throwing
			const emptyResponse = new GetLegalBenefitByIdResponse();
			return emptyResponse;
		}

		// For all other errors, log and rethrow
		console.error(err);
		throw err;
	}
};

export const listMatterBillingCodes = async (): Promise<ListMatterBillingCodesResponse> => {
	const token: string = getApiToken();
	const request: ListMatterBillingCodesRequest = new ListMatterBillingCodesRequest();
	const client: ClaimsBFFControllerClient = getBffRequest(token);

	try {
		return await client.listMatterBillingCodes(request, {});
	} catch (err) {
		console.error(err);
		throw err;
	}
};
